var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.68 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.32,9.87a.64.64,0,0,0-.64.64V20.72H15.55V15.15a3.21,3.21,0,0,0-6.42,0v5.57H4V10.51a.64.64,0,0,0-.64-.64.64.64,0,0,0-.64.64V21.36a.64.64,0,0,0,.64.64h18a.64.64,0,0,0,.64-.64V10.51A.64.64,0,0,0,21.32,9.87ZM14.26,20.72H10.42V15.15a1.92,1.92,0,1,1,3.84,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.42,8.69l-5.2-3.81V1.32a.64.64,0,0,0-.64-.64.64.64,0,0,0-.64.64V3.94L12.72.12a.66.66,0,0,0-.76,0L.26,8.69a.65.65,0,0,0-.14.9.65.65,0,0,0,.9.13L12.34,1.44,23.66,9.72a.6.6,0,0,0,.38.13.64.64,0,0,0,.38-1.16Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.67d33c81.svg";
export { ForwardRef as ReactComponent };